<template>
  <div id="servicios">
<div class="col-md-12 flecha-container">  
  <h1 data-aos="fade-up"  data-aos-duration="1500">SERVICIOS</h1>
    <img data-aos="fade-right"  data-aos-duration="1500" class="flecha" src="~imgs/icons/Flecha_Blanca.png">
  </div>    <div class="service-container">
      <div data-aos="fade-up"  data-aos-duration="1500" class="service-redbox">
        <img class="service-img" src="~imgs/icons/Servicios_Herramientas.png">
        <h3 name="img-text">LOGÍSTICA</h3>
      </div>
      <div data-aos="fade-up"  data-aos-duration="1500" class="service-redbox">
        <img class="service-img" src="~imgs/icons/Servicios_Location.png">
        <h3 name="img-text">GPS</h3>
      </div>
      <div data-aos="fade-up"  data-aos-duration="1500" class="service-redbox">
        <img class="service-img" src="~imgs/icons/Servicios_Ojo.png">
        <h3 name="img-text">MONITOREO</h3>
      </div>
       <div data-aos="fade-up"  data-aos-duration="1500" class="service-redbox">
        <img class="service-img" src="~imgs/icons/Servicios_Seguro.png">
        <h3 name="img-text">SEGURIDAD</h3>
      </div>
       <div data-aos="fade-up"  data-aos-duration="1500" class="service-redbox">
        <img class="service-img" src="~imgs/icons/Servicios_Truck.png">
        <h3 class="cruce-front" name="img-text">CRUCE FRONTERIZO</h3>
      </div>
       <div data-aos="fade-up"  data-aos-duration="1500" class="service-redbox">
        <img class="service-img" src="~imgs/icons/Servicios_Velocidad.png">
        <h3 name="img-text">ENTREGAS</h3>
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from './reusable/ArrowRight.vue'
export default{
  data(){
    return{

    }
  },
  props:['name', 'selector'],
  components: {
    Arrow
  }
}


</script>

<style lang="scss" scoped>
@import '~varmix';
#servicios{
  @include bgCover('~imgs/servicios_fondo.png');
  background-position:center;
  background-repeat:no-repeat;
  background-size:cover;
  height: 100%;
  height: 100%;
}
h3{
  color:#fff;
}

.service-img{
  width:200px;
}

.service-redbox{
  width:400px;
  text-align:center;
  background-color:$dark-red;
  padding:20px;
  display:inline-block;
  margin:10px;
  
}

.service-container{
  text-align:center;
  width:80%;
  margin:3% auto;
  border-bottom:10px;
  border-bottom-color:$dark-red;
  
}

@media screen and (max-width: 720px){
  .service-redbox{
  width:40%;
  text-align:center;
  background-color:$dark-red;
  padding:10px;
  display:inline-block;
  margin:10 10px;
}

 .service-redbox img{
  width:100%;
 }


.service-container{
  text-align:center;
  width:80%;
  margin:3% auto;
  border-bottom-color:$dark-red;
  
}
h3{
  color:#fff;
  font-size:7pt;
}
}

.flecha-container{
  width:100%;
  text-align:left;
}
.flecha-container h1{
float:right;
margin-right:20px;
margin-top:20px;
color:white;

font-size:30pt;
}
.flecha{
margin-left:-30px;
margin-top:20px;
width:80%;
}
</style>



// WEBPACK FOOTER //
// Servicios.vue?7608dd9c